import projectActionsMenuQueryParameters from '@atlassian/jira-relay/src/__generated__/AsyncMenuWithQueryQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueryParams = {
	cloudId: string;
	projectKey: string;
};

export const projectActionMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-project-actions-menu-content" */ './AsyncMenuWithQuery.tsx'
		).then((module) => module.AsyncMenuWithQuery),
	),
	getPreloadProps: ({ cloudId, projectKey }: QueryParams) => {
		const projectActionMenuQuery = {
			parameters: projectActionsMenuQueryParameters,
			variables: {
				cloudId,
				projectKey,
			},
			options: {
				fetchPolicy: 'store-and-network' as const,
			},
		};

		return {
			queries: {
				projectActionMenuQuery,
			},
		};
	},
});
